import { useContext, useEffect, useState } from "react";
import { DataContext } from "contexts/DataContext";

export const useBroadcast = ({user, includeMultiplier}) => {

  const { broadcasts, schedules } = useContext(DataContext)
  const [broadcastItems, loadingBrd, errorBrd, refreshBrd] = broadcasts;
  const [scheduleItems, loadingSch, errorSch, refreshSch] = schedules;

  return [broadcastItems.filter(b => includeMultiplier || !b.sourceId).map(b => {
    const schedule = scheduleItems ? scheduleItems.find(s => s.broadcastId === b.id) : null
    // Also cleared: the lists follow the database live, so after a schedule is removed the SAME
    // broadcast object comes back here and must not keep showing the old schedule
    if (schedule) {
      b.schedule = schedule
    } else {
      delete b.schedule
    }
    return b
  }), loadingSch || loadingBrd, errorSch || errorBrd, () => {
    // Resolves when both lists are reloaded, so callers can `await` it
    return Promise.all([refreshBrd(), refreshSch()])
  }];
};
